// import React, { useEffect, useState } from 'react';
// import '../contacts/Contact.css';
// import {
// 	TextField,
// 	Typography,
// 	IconButton,
// 	Dialog,
// 	DialogContent,
// 	DialogTitle,
// 	Container,
// 	Box,
// 	Button,
// 	DialogActions,
// } from '@mui/material';
// import Grid from '@mui/material/Grid2';
// import CloseIcon from '@mui/icons-material/Close';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import { GridValueGetter, GridColDef, GridToolbar } from '@mui/x-data-grid';
// import ViewUser from './ViewUser';
// import { StyledCrossIconButton, StyledDataGrid } from '../../component/ThemeComponent';
// import { getAllUserAPI } from '../../../services/api/UsersAPI';

// interface UserCardProps {
// 	_id: string;
// 	firstName: string;
// 	lastName: string;
// 	email: string;
// 	mobile: string;
// 	status: number;
// 	createdAt?: string;
// 	updatedAt?: string;
// 	profileImage?: string;
// 	shippingAddress?: {
// 		fullName: string;
// 		email: string;
// 		phone: string;
// 		address: string;
// 		state: string;
// 		zipCode: string;
// 		country: string;
// 		city: string;
// 		active: boolean;
// 		_id: string;
// 	}[];
// }

// interface GridRowParams {
// 	row: UserCardProps;
// }

// const Users = () => {
// 	const [contacts, setContacts] = useState<UserCardProps[]>([]);
// 	const [searchTerm, setSearchTerm] = useState('');
// 	const [openDialog, setOpenDialog] = useState(false);
// 	const [currentProduct, setCurrentProduct] = useState<UserCardProps | null>(null);

// 	const handleViewProduct = (product: UserCardProps) => {
// 		setCurrentProduct(product);
// 		setOpenDialog(true);
// 	};

// 	const handleCloseDialog = () => {
// 		setOpenDialog(false);
// 		setCurrentProduct(null);
// 	};

// 	useEffect(() => {
// 		fetchData();
// 	}, []);

// 	const fetchData = async () => {
// 		const response = await getAllUserAPI();
// 		if (response.success) {
// 			const mappedContacts = response.data.user.map((user: any) => ({
// 				_id: user._id,
// 				firstName: user.firstName,
// 				lastName: user.lastName,
// 				email: user.email,
// 				mobile: user.mobile,
// 				status: user.status,
// 				createdAt: user.createdAt,
// 				updatedAt: user.updatedAt,
// 				profileImage: user.profileImage,
// 				shippingAddress: user.shippingAddress,
// 			}));
// 			setContacts(mappedContacts);
// 		}
// 	};

// 	const filteredContacts = contacts.filter((contact) =>
// 		`${contact.firstName} ${contact.lastName}`.toLowerCase().includes(searchTerm.toLowerCase())
// 	);

// 	const createdAtDate: GridValueGetter<(typeof contacts)[number], unknown> = (value, row) =>
// 		`${
// 			new Date(row.createdAt ?? '')
// 				.toLocaleString('en-GB', {
// 					day: '2-digit',
// 					month: 'short',
// 					year: 'numeric',
// 					hour: '2-digit',
// 					minute: '2-digit',
// 					hour12: true,
// 				})
// 				.replace(/,/g, '')
// 				.replace(/(\d+)\/(\d+)\/(\d+),? (\d+:\d+) (AM|PM)/, '$1-$2-$3 $4 $5') || 'N/A'
// 		}`;

// 	const updatedAtDate: GridValueGetter<(typeof contacts)[number], unknown> = (value, row) =>
// 		`${
// 			new Date(row.updatedAt ?? '')
// 				.toLocaleString('en-GB', {
// 					day: '2-digit',
// 					month: 'short',
// 					year: 'numeric',
// 					hour: '2-digit',
// 					minute: '2-digit',
// 					hour12: true,
// 				})
// 				.replace(/,/g, '')
// 				.replace(/(\d+)\/(\d+)\/(\d+),? (\d+:\d+) (AM|PM)/, '$1-$2-$3 $4 $5') || 'N/A'
// 		}`;

// 	const columns: GridColDef[] = [
// 		{ field: 'firstName', headerName: 'First Name', width: 150, type: 'string' },
// 		{ field: 'lastName', headerName: 'Last Name', width: 150, type: 'string' },
// 		{ field: 'email', headerName: 'Email', width: 200, type: 'string' },
// 		{ field: 'mobile', headerName: 'Mobile No', width: 130, type: 'string' },
// 		{
// 			field: 'createdAt',
// 			headerName: 'Lead Date',
// 			width: 180,
// 			type: 'string',
// 			valueGetter: createdAtDate,
// 		},
// 		{
// 			field: 'updatedAt',
// 			headerName: 'Update Date',
// 			width: 130,
// 			type: 'string',
// 			valueGetter: updatedAtDate,
// 		},
// 		{
// 			field: 'actions',
// 			headerName: 'Actions',
// 			width: 120,
// 			type: 'actions',
// 			renderCell: (params: GridRowParams) => (
// 				<div style={{ display: 'flex', flexDirection: 'row' }}>
// 					<IconButton onClick={() => handleViewProduct(params.row)}>
// 						<VisibilityIcon />
// 					</IconButton>
// 				</div>
// 			),
// 		},
// 	];

// 	return (
// 		<Container>
// 			<div
// 				className="d-flex"
// 				style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
// 			>
// 				<div>
// 					<Typography
// 						gutterBottom
// 						style={{ fontFamily: 'Poppins', fontWeight: '700', fontSize: '24px' }}
// 					>
// 						Users
// 					</Typography>
// 					<span
// 						style={{
// 							fontFamily: 'Poppins',
// 							fontWeight: '400',
// 							fontSize: '14px',
// 							color: '#006D48',
// 						}}
// 					>
// 						Manage your Users list and View details.
// 					</span>
// 				</div>
// 			</div>

// 			<Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
// 				<Grid size={{ xs: 12 }}>
// 					<TextField
// 						label="Search Users"
// 						variant="outlined"
// 						margin="none"
// 						value={searchTerm}
// 						onChange={(e) => setSearchTerm(e.target.value)}
// 						size="small"
// 						fullWidth
// 						sx={{ marginTop: '10px' }}
// 					/>
// 				</Grid>
// 			</Grid>

// 			<Box sx={{ height: 600, width: 'auto' }}>
// 				<StyledDataGrid
// 					rows={filteredContacts}
// 					columns={columns}
// 					initialState={{
// 						pagination: {
// 							paginationModel: { pageSize: 10 },
// 						},
// 					}}
// 					slots={{ toolbar: GridToolbar }}
// 					pageSizeOptions={[10]}
// 					getRowId={(row) => row._id}
// 				/>
// 			</Box>

// 			<Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
// 				<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
// 					<span>View Contact</span>
// 					<StyledCrossIconButton onClick={handleCloseDialog}>
// 						<CloseIcon />
// 					</StyledCrossIconButton>
// 				</DialogTitle>
// 				<DialogContent>
// 					<ViewUser product={currentProduct} isDisabled={true} />
// 				</DialogContent>
// 				<DialogActions>
// 					<Button onClick={handleCloseDialog} color="primary">
// 						Cancel
// 					</Button>
// 				</DialogActions>
// 			</Dialog>
// 		</Container>
// 	);
// };

// export default Users;
// ============================================================================================================================
// ============================================================================================================================
// ============================================================================================================================
// ============================================================================================================================
// ============================================================================================================================
// ============================================================================================================================
// ============================================================================================================================
// ============================================================================================================================
import React, { useEffect, useState } from 'react';
import '../contacts/Contact.css';
import {
	TextField,
	Typography,
	IconButton,
	Dialog,
	DialogContent,
	DialogTitle,
	Container,
	Box,
	Button,
	DialogActions,
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { GridValueGetter, GridColDef, GridToolbar } from '@mui/x-data-grid';
import ViewUser from './ViewUser';
import { StyledCrossIconButton, StyledDataGrid } from '../../component/ThemeComponent';
import { getAllUserAPI } from '../../../services/api/UsersAPI';

interface UserCardProps {
	_id: string;
	firstName: string;
	lastName: string;
	email: string;
	mobile: string;
	status: number;
	createdAt?: string;
	updatedAt?: string;
	profileImage?: string;
	shippingAddress?: {
		fullName: string;
		email: string;
		phone: string;
		address: string;
		state: string;
		zipCode: string;
		country: string;
		city: string;
		active: boolean;
		_id: string;
	}[];
}

interface GridRowParams {
	row: UserCardProps;
}

const Users = () => {
	const [contacts, setContacts] = useState<UserCardProps[]>([]);
	const [searchTerm, setSearchTerm] = useState('');
	const [openDialog, setOpenDialog] = useState(false);
	const [currentProduct, setCurrentProduct] = useState<UserCardProps | null>(null);

	const handleViewProduct = (product: UserCardProps) => {
		setCurrentProduct(product);
		setOpenDialog(true);
	};

	const handleCloseDialog = () => {
		setOpenDialog(false);
		setCurrentProduct(null);
	};

	useEffect(() => {
		fetchData();
	}, []);

	const fetchData = async () => {
		const response = await getAllUserAPI();
		if (response.success) {
			const mappedContacts = response.data.user.map((user: any) => ({
				_id: user._id,
				firstName: user.firstName,
				lastName: user.lastName,
				email: user.email,
				mobile: user.mobile,
				status: user.status,
				createdAt: user.createdAt,
				updatedAt: user.updatedAt,
				profileImage: user.profileImage,
				shippingAddress: user.shippingAddress,
			}));
			setContacts(mappedContacts);
		}
	};

	const filteredContacts = contacts.filter((contact) =>
		`${contact.firstName} ${contact.lastName} ${contact.email} ${contact.mobile}`
			.toLowerCase()
			.includes(searchTerm.toLowerCase())
	);

	const createdAtDate: GridValueGetter<(typeof contacts)[number], unknown> = (value, row) =>
		`${
			new Date(row.createdAt ?? '')
				.toLocaleString('en-GB', {
					day: '2-digit',
					month: 'short',
					year: 'numeric',
					hour: '2-digit',
					minute: '2-digit',
					hour12: true,
				})
				.replace(/,/g, '')
				.replace(/(\d+)\/(\d+)\/(\d+),? (\d+:\d+) (AM|PM)/, '$1-$2-$3 $4 $5') || 'N/A'
		}`;

	const updatedAtDate: GridValueGetter<(typeof contacts)[number], unknown> = (value, row) =>
		`${
			new Date(row.updatedAt ?? '')
				.toLocaleString('en-GB', {
					day: '2-digit',
					month: 'short',
					year: 'numeric',
					hour: '2-digit',
					minute: '2-digit',
					hour12: true,
				})
				.replace(/,/g, '')
				.replace(/(\d+)\/(\d+)\/(\d+),? (\d+:\d+) (AM|PM)/, '$1-$2-$3 $4 $5') || 'N/A'
		}`;

	const columns: GridColDef[] = [
		{ field: 'firstName', headerName: 'First Name', width: 150, type: 'string' },
		{ field: 'lastName', headerName: 'Last Name', width: 150, type: 'string' },
		{ field: 'email', headerName: 'Email', width: 200, type: 'string' },
		{ field: 'mobile', headerName: 'Mobile No', width: 130, type: 'string' },
		{
			field: 'createdAt',
			headerName: 'Lead Date',
			width: 180,
			type: 'string',
			valueGetter: createdAtDate,
		},
		{
			field: 'updatedAt',
			headerName: 'Update Date',
			width: 130,
			type: 'string',
			valueGetter: updatedAtDate,
		},
		{
			field: 'actions',
			headerName: 'Actions',
			width: 120,
			type: 'actions',
			renderCell: (params: GridRowParams) => (
				<div style={{ display: 'flex', flexDirection: 'row' }}>
					<IconButton onClick={() => handleViewProduct(params.row)}>
						<VisibilityIcon />
					</IconButton>
				</div>
			),
		},
	];

	return (
		<Container>
			<div
				className="d-flex"
				style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
			>
				<div>
					<Typography
						gutterBottom
						style={{ fontFamily: 'Poppins', fontWeight: '700', fontSize: '24px' }}
					>
						Users
					</Typography>
					<span
						style={{
							fontFamily: 'Poppins',
							fontWeight: '400',
							fontSize: '14px',
							color: '#006D48',
						}}
					>
						Manage your Users list and View details.
					</span>
				</div>
			</div>

			<Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
				<Grid size={{ xs: 12 }}>
					<TextField
						label="Search Users"
						variant="outlined"
						margin="none"
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
						size="small"
						fullWidth
						sx={{ marginTop: '10px' }}
					/>
				</Grid>
			</Grid>

			<Box sx={{ height: 600, width: 'auto' }}>
				<StyledDataGrid
					rows={filteredContacts}
					columns={columns}
					initialState={{
						pagination: {
							paginationModel: { pageSize: 10 },
						},
					}}
					slots={{ toolbar: GridToolbar }}
					pageSizeOptions={[10]}
					getRowId={(row) => row._id}
				/>
			</Box>

			<Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
				<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
					<span>View Users</span>
					<StyledCrossIconButton onClick={handleCloseDialog}>
						<CloseIcon />
					</StyledCrossIconButton>
				</DialogTitle>
				<DialogContent>
					<ViewUser product={currentProduct} isDisabled={true} />
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCloseDialog} color="primary">
						Cancel
					</Button>
				</DialogActions>
			</Dialog>
		</Container>
	);
};

export default Users;
